<template>
  <div class="p-home">
    <!-- <div>
      <img class="banner-img" src="../../assets/img/banner.png" alt="" />
    </div> -->
    <div class="banner">
      <div class="ban-title">成人高考宝典APP</div>
      <div class="ban-subtitle">让学习成为习惯</div>
      <div class="ban-code">
        <img class="image" src="@/assets/img/qrcode.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";
export default {
  mixins: [page_mx],
  data() {
    return {
      isUserLogin: false,
    };
  },
  methods: {
    // 初始化
    async init() {},
  },
};
</script>
<style lang="less" scope>
.clear:after {
  content: "";
  height: 0;
  display: block;
  clear: both;
}

.banner-img {
  width: 100%;
}

.banner {
  height: 460px;
  width: 1160px;
  margin-left: auto;
  margin-right: auto;
  background-image: url(~@/assets/img/detail.png);
  background-repeat: no-repeat;
  background-position: right;
  .ban-title {
    font-size: 60px;
    color: #333;
    margin-top: 60px;
  }

  .ban-subtitle {
    color: #666;
    font-size: 24px;
    margin-top: 30px;
  }

  .ban-code {
    width: 156px;
    height: 156px;
    cursor: pointer;
    .image {
      margin-top: 40px;
      border-radius: 10px;
      width: 100%;
      height: 100%;
    }
    .image:hover {
      box-shadow: 0px 0px 8px 0px rgba(121, 174, 149, 0.4);
    }
  }
}
</style>
